import React, { ComponentType } from 'react';

import { UserProps } from './types';
import { FeatureFlowProvider } from '../contexts/FeatureFlowContext';

function withContext(WrappedComponent: ComponentType<UserProps>) {
  function withContextWrapper(props: UserProps) {
    return (
      <FeatureFlowProvider>
        <WrappedComponent {...props} />
      </FeatureFlowProvider>
    );
  }
  return React.memo(withContextWrapper);
}

export default withContext;
